import axios from 'axios';
import AuthService from './AuthService';

function onSessionExpired(err: any) {
	if (err?.response && err.response.status === 401) {
		AuthService.handleSessionExpired();
	}
	return Promise.reject(err?.response ?? err);
}

function onAuthEndpointError(err: any) {
	return Promise.reject(err?.response ?? err);
}

function onTokenCheckError(err: any) {
	if (err?.response && [400, 401, 403].includes(err.response.status)) {
		AuthService.handleSessionExpired();
	}
	return Promise.reject(err?.response ?? err);
}

const authApi = axios.create({
	baseURL: process.env.REACT_APP_AUTH_URL
});

const eventApi = axios.create({
	baseURL: process.env.REACT_APP_EVENT_URL,
});

const eventMarketingApi = axios.create({
	baseURL: process.env.REACT_APP_EVENT_MARKETING_URL
})

const ordersApi = axios.create({
	baseURL: process.env.REACT_APP_ORDERS_URL,
});

const ordersV2Api = axios.create({
	baseURL: process.env.REACT_APP_ORDERS_V2_URL,
});

const salesApi = axios.create({
	baseURL: process.env.REACT_APP_SALES_URL_V2,
});

const checkTokenApi = axios.create({
	baseURL: process.env.REACT_APP_CHECK_TOKEN_URL,
});

//TODO remove duplications
eventApi.interceptors.request.use(config => {
	const expirationToken: any = AuthService.getTokenExpirationDate();
	config.headers['Content-Type'] = 'application/json';
	config.headers['Accept-Language'] = process.env.REACT_APP_MAIN_LANGUAGE;

	if (expirationToken) {
		if (Date.now() <= parseInt(expirationToken) * 1000) {
			config.headers['Authorization'] = `Bearer ${AuthService.getAccessToken()}`;
			return config;
		}
	}

	config.headers['tenant_id'] = process.env.REACT_APP_TENANT_ID;
	return config;
});

eventApi.interceptors.response.use(undefined, onSessionExpired);

eventMarketingApi.interceptors.request.use(config => {
	const expirationToken: any = AuthService.getTokenExpirationDate();
	config.headers['Content-Type'] = 'application/json';
	config.headers['Accept-Language'] = process.env.REACT_APP_MAIN_LANGUAGE;

	if (expirationToken) {
		if (Date.now() <= parseInt(expirationToken) * 1000) {
			config.headers['Authorization'] = `Bearer ${AuthService.getAccessToken()}`;
			return config;
		}
	}

	config.headers['tenant_id'] = process.env.REACT_APP_TENANT_ID;
	return config;
});

eventMarketingApi.interceptors.response.use(undefined, onSessionExpired);

ordersApi.interceptors.request.use(config => {
	const expirationToken: any = AuthService.getTokenExpirationDate();
	config.headers['Content-Type'] = 'application/json';
	config.headers['Accept-Language'] = process.env.REACT_APP_MAIN_LANGUAGE;
	config.headers['tenant_id'] = process.env.REACT_APP_TENANT_ID;

	if (expirationToken) {
		if (Date.now() <= parseInt(expirationToken) * 1000) {
			config.headers['Authorization'] = `Bearer ${AuthService.getAccessToken()}`;
			return config;
		}
	}
	return config;
});

salesApi.interceptors.request.use(config => {
	const expirationToken: any = AuthService.getTokenExpirationDate();
	config.headers['Content-Type'] = 'application/json';
	config.headers['Accept-Language'] = process.env.REACT_APP_MAIN_LANGUAGE;

	if (expirationToken) {
		if (Date.now() <= parseInt(expirationToken) * 1000) {
			config.headers['Authorization'] = `Bearer ${AuthService.getAccessToken()}`;
			return config;
		}
	}

	config.headers['tenant_id'] = process.env.REACT_APP_TENANT_ID;
	return config;
});

salesApi.interceptors.response.use(undefined, onSessionExpired);

authApi.interceptors.request.use(config => {
	const expirationToken: any = AuthService.getTokenExpirationDate();
	config.headers['Content-Type'] = 'application/json';
	config.headers['Accept-Language'] = process.env.REACT_APP_MAIN_LANGUAGE;

	if (expirationToken) {
		if (Date.now() <= parseInt(expirationToken) * 1000) {
			config.headers['Authorization'] = `Bearer ${AuthService.getAccessToken()}`;
			return config;
		}
	}

	config.headers['tenant_id'] = process.env.REACT_APP_TENANT_ID;
	return config;
});

authApi.interceptors.response.use(undefined, onAuthEndpointError);

checkTokenApi.interceptors.response.use(undefined, onTokenCheckError);

ordersApi.interceptors.response.use(undefined, onSessionExpired);

ordersV2Api.interceptors.request.use(config => {
	config.headers['Content-Type'] = 'application/json';
	config.headers['Accept-Language'] = process.env.REACT_APP_MAIN_LANGUAGE;
	config.headers['tenant_id'] = process.env.REACT_APP_TENANT_ID;
	return config;
});

ordersV2Api.interceptors.response.use(undefined, onSessionExpired);

export {
	authApi,
	eventApi,
	eventMarketingApi,
	ordersApi,
	ordersV2Api,
	salesApi,
	checkTokenApi
};
